<template>
  <div class="card-group my-3">
    <div class="card">
      <div class="card-body d-flex flex-column justify-content-between gap-3 text-center">
        <div>Security warnings</div>
        <div class="audit-stat text-danger">{{ stats.filteredHasSecurityWarning }}</div>
      </div>
    </div>
    <div class="card">
      <div class="card-body d-flex flex-column justify-content-between gap-3 text-center">
        <div>Outdated</div>
        <div class="audit-stat text-warning">{{ stats.filteredOutdated }}</div>
      </div>
    </div>
    <div class="card">
      <div class="card-body d-flex flex-column justify-content-between gap-3 text-center">
        <div>Up-to-date</div>
        <div class="audit-stat text-success">{{ stats.filteredUpToDate }}</div>
      </div>
    </div>
    <div class="card">
      <div class="card-body d-flex flex-column justify-content-between gap-3 text-center">
        <div>Dependencies</div>
        <div class="audit-stat">{{ stats.filteredCount }}</div>
      </div>
    </div>
    <div class="card">
      <div class="card-body d-flex flex-column justify-content-between gap-3 bg-dark-subtle text-center">
        <div>Total score</div>
        <div class="audit-stat">{{ stats.scorePercent }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  stats: {
    type: Object,
    required: true
  }
});
</script>

<style scoped>
.audit-stat {
  font-size: 3rem;
  font-weight: bold;
}
</style>
